module.exports = __webpack_public_path__ + "img/mile4m.4f68851e.jpg";